
const EXCEPTION_CODES = {
    USER_VIDEO_PERMISSION_DENIED_ERROR_CODE: 107,
    USER_AUDIO_PERMISSION_DENIED_ERROR_CODE: 108
};
export {
    EXCEPTION_CODES,
};
